import React from 'react';
import { BrowserRouter, Navigate, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import ScrollToTop from './components/ScrollToTop';
import { ROUTES } from './routes';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Security from './pages/Security';
import CaseStudies from './pages/CaseStudies';
import Contact from './pages/Contact';

function App() {
  return (
    <BrowserRouter>
      <MotionConfig reducedMotion="user">
        <ScrollToTop />
        <div style={{ background: 'var(--bg)', minHeight: '100vh' }}>
          <Routes>
            <Route path={ROUTES.home} element={<Home />} />
            <Route path={ROUTES.howItWorks} element={<HowItWorks />} />
            <Route path={ROUTES.security} element={<Security />} />
            <Route path={ROUTES.caseStudies} element={<CaseStudies />} />
            <Route path={ROUTES.adoptionLegacy} element={<Navigate to={ROUTES.caseStudies} replace />} />
            <Route path={ROUTES.contact} element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
      </MotionConfig>
    </BrowserRouter>
  );
}

export default App;
